import KendoPanelBarMixin from './KendoPanelBarMixin'

export default {
    name: 'kendo-panelbar',
    mixins: [ KendoPanelBarMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoPanelBar/index.js